import { render, staticRenderFns } from "./AccordionWrapper.vue?vue&type=template&id=861df294&scoped=true&"
import script from "./AccordionWrapper.vue?vue&type=script&lang=js&"
export * from "./AccordionWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AccordionWrapper.vue?vue&type=style&index=0&id=861df294&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861df294",
  null
  
)

export default component.exports